// extracted by mini-css-extract-plugin
export default {"subscriptionId":"SubscriptionIdCell_subscriptionId__r4e8v"};